// 过滤器function
// 普通用户来源（）
export const userForm = type => {
    type = type * 1;
    let str = "";
    switch (type) {
        case 1:
            str = "APP用户";
            break;
        case 2:
            str = "微信用户";
            break;
        case 3:
            str = "卡片用户";
            break;
        case 4:
            break;
        case 5:
            break;
        default:
            str = type;
            break;
    }
    return str;
};
// 普通用户来源（app）
export const userFormApp = type => {
    type = type * 1;
    switch (type) {
        case 0:
            return "回收端";
            break;
        case 1:
            return "用户端";
            break;
        case 2:
            return "分拣-管理";
            break;
        case 3:
            return "兑换端";
            break;
        case 4:
            return "分拣-司机";
            break;
        default:
            return type;
            break;
    }
};

// 订单状态（app）
export const orderType = type => {
    type = type * 1;
    switch (type) {
        case 1:
            return "待接单";
            break;
        case 2:
            return "待上门";
            break;
        case 3:
            return "待称重";
            break;
        case 4:
            return "待支付";
            break;
        case 5:
            return "已取消";
            break;
        case 6:
            return "已完成";
            break;
        case 7:
            return "待上门";
        case 8:
            return "待核重";
        case 9:
            return "已派单，待接单";
        case 10:
            return "司机已拒单";
        case 11:
            return "待定价";
        case 12:
            return "待确认";
        default:
            return type;
            break;
    }
};
// 兔管家订单状态
export const rabbitType = type => {
    type = type * 1;
    switch (type) {
        case 1:
            return "称毛重";
            break;
        case 2:
            return "称皮重";
            break;
        case 3:
            return "已完成";
            break;
        case 4:
            return "待支付";
            break;
        case 5:
            return "已定价";
            break;
        case 9:
            return "已取消";
            break;
        default:
            return type;
            break;
    }
};
// 运单状态
export const skipType = type => {
    type = type * 1;
    switch (type) {
        case 1:
            return "待调度";
            break;
        case 2:
            return "待派单";
            break;
        case 3:
            return "待接单";
            break;
        case 4:
            return "运输中";
            break;
        case 5:
            return "已完成";
            break;
        case 6:
            return "异常";
            break;
        case 7:
            return "已取消";
            break;
        case 8:
            return "待结算";
            break;
    }
};

// 交易类型
export const dealType = type => {
    type = type * 1;
    switch (type) {
        case 1:
            return "品类回收";
            break;
        case 2:
            return "大件上门";
            break;
        case 3:
            return "分拣中心";
            break;
        case 6:
            return "提现";
            break;
        case 7:
            return "提现中";
            break;
        case 25:
            return "积分兑换";
            break;
        case 30:
            return "系统调整";
            break;
        case 50:
            return "市民卡充值";
            break;
        case 51:
            return "市民卡合并";
            break;
    }
};
// 物流管理 运单状态
export const waybillType = type => {
    type = type * 1;
    switch (type) {
        case 3:
            return "待取货";
            break;
        case 4:
            return "运输中";
            break;
        case 5:
            return "支付完成";
            break;
        case 6:
            return "待确认";
            break;
        case 7:
            return "已取消";
            break;
        case 8:
            return "运输完成";
            break;
    }
};
// 包裹申诉
export const packType = type => {
    type = type * 1;
    switch (type) {
        case 4:
            return "代付款";
            break;
        case 5:
            return "未取货";
            break;
        case 6:
            return "已完成";
            break;
        case 7:
            return "待确认";
            break;
        case 8:
            return "待结算";
            break;
        case 10:
            return "司机已拒单";
            break;
        case 11:
            return "丢失";
            break;
        case 12:
            return "确认";
            break;
    }
};
// 物流运单状态
export const wuLiuType = type => {
    type = type * 1;
    switch (type) {
        case 1:
            return "待取货";
            break;

        case 5:
            return "已取消";
            break;
        case 6:
            return "已结算";
            break;
        case 7:
            return "待确认";
            break;
        case 8:
            return "待结算";
            break;
    }
};

//包裹列表状态
export const baoLtYPE = type => {
    type = type * 1;
    switch (type) {
        case 5:
            return "待结算";
            break;
        case 7:
            return "待确认";
            break;
        case 6:
            return "已完成";
            break;
        case 8:
            return "包裹丢失";
            break;
    }
};